import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_VALIDATE_CUSTOMER_BEGIN,
  MANAGE_SUBS_VALIDATE_CUSTOMER_SUCCESS,
  MANAGE_SUBS_VALIDATE_CUSTOMER_FAILURE,
  MANAGE_SUBS_VALIDATE_CUSTOMER_DISMISS_ERROR,
} from './constants';

export function validateCustomer(site,customerId) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_VALIDATE_CUSTOMER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.get(`${API_REQUEST_URL}/isValidCustomer?customerId=${customerId}&site=${site}`, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_VALIDATE_CUSTOMER_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_VALIDATE_CUSTOMER_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissValidateCustomerError() {
  return {
    type: MANAGE_SUBS_VALIDATE_CUSTOMER_DISMISS_ERROR,
  };
}

export function useValidateCustomer() {
  const dispatch = useDispatch();

  const { validateCustomerPending, validateCustomerError } = useSelector(
    state => ({
      validateCustomerPending: state.manageSubs.validateCustomerPending,
      validateCustomerError: state.manageSubs.validateCustomerError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(validateCustomer(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissValidateCustomerError());
  }, [dispatch]);

  return {
    validateCustomer: boundAction,
    validateCustomerPending,
    validateCustomerError,
    dismissValidateCustomerError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_VALIDATE_CUSTOMER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        validateCustomerPending: true,
        validateCustomerError: null,
      };

    case MANAGE_SUBS_VALIDATE_CUSTOMER_SUCCESS:
      // The request is success
      return {
        ...state,
        validateCustomerPending: false,
        validateCustomerError: null,
      };

    case MANAGE_SUBS_VALIDATE_CUSTOMER_FAILURE:
      // The request is failed
      return {
        ...state,
        validateCustomerPending: false,
        validateCustomerError: action.data.error,
      };

    case MANAGE_SUBS_VALIDATE_CUSTOMER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        validateCustomerError: null,
      };

    default:
      return state;
  }
}
